// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sputnik__MaskedFormTextInput__r3VUI .TextInput-right-icon{right:0}`, "",{"version":3,"sources":["webpack://./src/components/MaskedFormTextInput/styles.module.scss"],"names":[],"mappings":"AACE,2DACE,OAAA","sourcesContent":[".MaskedFormTextInput {\n  :global(.TextInput-right-icon) {\n    right: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"MaskedFormTextInput": `sputnik__MaskedFormTextInput__r3VUI`
};
export default ___CSS_LOADER_EXPORT___;
